import { faAngleLeft } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NSInput } from 'bricks';
import { NSButtonBase } from 'bricks/NSButton/NSButton';
import NSInfoBanner from 'components/NSInfoBanner/NSInfoBanner';
import React from 'react';
import { ISignUpManager } from 'views/public/SignUp/useSignUpManager';
import { IValidateSignupResponse } from 'views/public/SignUp/hooks/useValidateSignup';

export interface IManualSignupFormProps {
    signUpManager: ISignUpManager;
    onClickBack: () => void;
    userOrgLookupData?: IValidateSignupResponse;
}

const ManualSignupForm = ({ signUpManager, onClickBack, userOrgLookupData }: IManualSignupFormProps) => {
    const {
        signUpEnabled,
        jobTitle,
        organizationName,
        name,
        validCaptcha,
        handleJobTitleChange,
        handleOrganizationNameChange,
        handleNameChange,
        handleSignUp,
    } = signUpManager;

    return (
        <div className="w-50">
            <div className="text-center">
                <button
                    type="button"
                    className="DirectSignUp__SwitchPhaseButton mb-0 heap-deal-signup-step-5-back"
                    onClick={onClickBack}
                    data-testid="backButton"
                >
                    <FontAwesomeIcon icon={faAngleLeft} className="mr-1" />
                    {' '}
                    Back
                </button>
                <h1 className="text-white mt-0">Finish account setup</h1>
            </div>
            <div className="DirectSignUp__FormFields">
                <label htmlFor="name" className="DirectSignUp__SectionLabel text-white">Your information</label>
                <NSInput
                    id="name"
                    name="name"
                    type="text"
                    placeholder="Enter name"
                    value={name.value}
                    onChange={handleNameChange}
                    autoComplete="name"
                />
                <NSInput
                    name="jobTitle"
                    type="text"
                    placeholder="Job title"
                    value={jobTitle.value}
                    onChange={handleJobTitleChange}
                    autoComplete="job-title"
                />
                {!userOrgLookupData?.org && (
                    <NSInput
                        id="organizationName"
                        name="organizationName"
                        type="text"
                        placeholder="Organization name"
                        value={organizationName.value}
                        onChange={handleOrganizationNameChange}
                        autoComplete="organization"
                        invalid={!!organizationName.errorMsg}
                        showErrorMsg={!!organizationName.errorMsg}
                        errorMsg={organizationName.errorMsg}
                    />
                )}
                <hr className="DirectSignUp__StandaloneDivider" />
                {!validCaptcha && (
                    <NSInfoBanner title="Whoops! Seems you are not Human!" warning className="DirectSignUp__InvalidCaptcha" />
                )}
                <div className="mt-0">
                    <NSButtonBase
                        color="primary"
                        callback={handleSignUp}
                        className="DirectSignUp__Button heap-deal-signup-step-5-create-account"
                        disabled={!signUpEnabled}
                        dataTestId="signUpButton"
                    >
                        Create account
                    </NSButtonBase>
                </div>
            </div>
        </div>
    );
};

export default ManualSignupForm;
